import { NgModule } from '@angular/core';
import { MaterialModule } from '@material/material.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@shared/shared.module';
import { BTaxModule } from '../btax/btax.module';
import { PPTModule } from '../ppt/ppt.module';
import { LookupRoutingModule } from './lookup-routing.module';
import { LookupComponent } from './pages/lookup/lookup.component';
import { MarkPipe } from './pages/lookup/mark.pipe';
import { lookupFeatureEffects } from './state/lookup.effects';
import { LOOKUP_FEATURE_STATE_KEY } from './state/lookup.key';
import { lookupFeatureReducer } from './state/lookup.reducer';

@NgModule({
    declarations:
    [
        LookupComponent,
        MarkPipe,
    ],
    imports:
    [
        SharedModule,
        MaterialModule,

        LookupRoutingModule,

        PPTModule,
        BTaxModule,

        StoreModule.forFeature(LOOKUP_FEATURE_STATE_KEY, lookupFeatureReducer),
        EffectsModule.forFeature(lookupFeatureEffects),
    ]
})
export class LookupModule { }
